function wm_init_accordions() {
    let accordions = document.querySelectorAll('[data-accordion-toggle]');

    if (!accordions.length) {
        return;
    }

    accordions.forEach(el => {
        el.addEventListener('click', function() {
            let parent = this.closest('[data-accordion-parent]');
            parent.classList.toggle('is-active');

            if (this.dataset.accordionToggle == 'caption') {
                this.textContent = parent.classList.contains('is-active') ? wm_vars.caption_less : wm_vars.caption_more;
            }

            return false;
        });
    });
}

wm_init_accordions();
